const test = {
    id: null,
    questionCount: 0,
};

const testModule = {
    namespaced: true,
    state: {
        testing: test,
    },
    getters: {
        getQuestionCount: state => state.testing.questionCount,
        getTestId: state => state.testing.id,
    },
    mutations: {
        SET_TESTING: (state, test) => {
            state.testing = test;
        },
        INCREMENT_QUESTION_COUNT: (state) => {
            state.testing.questionCount++;
        }
    },
    actions: {
        setTest: ({commit}, value) => {
            commit('SET_TESTING', test);
            commit('SET_TESTING', value);
        },
        resetCurrentTest: ({commit}) => {
            commit('SET_TESTING', test);
        },
        incrementQuestionCount: ({commit}) => {
            commit('INCREMENT_QUESTION_COUNT');
        }
    }
};

export default testModule;